import { render } from "./bidDetailPanel.vue?vue&type=template&id=472399d2&scoped=true"
import script from "./bidDetailPanel.vue?vue&type=script&lang=js"
export * from "./bidDetailPanel.vue?vue&type=script&lang=js"

import "./bidDetailPanel.vue?vue&type=style&index=0&id=472399d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472399d2"]])

export default __exports__